import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import TabSlider from "../menu-items/tab-slider";
import ExpertsHistory from "./experts/experts_history.component";
import Help from "../_helper/help.component";
import ExpertsPackages from "./experts/experts_packages.component";
import ExpertsInfo from "./experts/experts_info.component";

export enum menu {
    INFO = "info",
    HISTORY = "history",
    PACKAGES = "packages",
}

type RouteParams = {
    mainMenu: string
    subMenu:string
}


/**
 * Experts page
 *
 */
function Experts() {

    // params for the tab menu
    const params = useParams<RouteParams>();

    //tabs
    const [key, setKey] = useState<menu>(menu.INFO);

    // for checking window width to toggle mobile tabs navigation
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
    const MAX_WIDTH = 500;
    const checkWindowWidth = (condition: string = "lte", threshold: number = MAX_WIDTH) => (condition === "lte" ? windowWidth <= threshold : windowWidth > threshold);
    const detectSize = () => { setWindowWidth(window.innerWidth); };
    
    const [activeTab, setActiveTab] = useState<menu>(menu.INFO);
    const isTabActive = (tabName: menu) => (activeTab === tabName ? "active" : "");

    const navigate = useNavigate();

    //Translation
    const { t } = useTranslation();

    useEffect(() => {
        window.addEventListener("resize", detectSize);
        return () => { window.removeEventListener("resize", detectSize); };
    }, [windowWidth]);

    useEffect(() =>  {
        if(params.subMenu && params.subMenu !== key) {
            setKey(params.subMenu as menu);
            setActiveTab(params.subMenu as menu)
        }      
    }, [ params.subMenu ])
    
    function handleSetKey(tabItem: menu) {
        navigate("/dashboard/account/" + params.mainMenu + "/" + tabItem);
    }


    return (
        <div className="profile-container">
            <TabSlider checkWindowWidth={checkWindowWidth} maxWidth={MAX_WIDTH}>
                <li className={isTabActive(menu.INFO)} onClick={() => { handleSetKey(menu.INFO); }}>{t("Info")}</li>
                <li className={isTabActive(menu.HISTORY)} onClick={() => { handleSetKey(menu.HISTORY); }}>{t("History")}</li>
                <li className={isTabActive(menu.PACKAGES)} onClick={() => { handleSetKey(menu.PACKAGES); }}>{t("Packages")}</li>
            </TabSlider>
            {(checkWindowWidth() && isTabActive(menu.INFO)) && 
                <div>
                    <ExpertsInfo />
                    <Help category={"MyAccount"} pageName={"Experts - Info"}></Help>
                </div>
            }
            
            {(checkWindowWidth() && isTabActive(menu.HISTORY)) && 
                <div>
                    <ExpertsHistory />
                    <Help category={"MyAccount"} pageName={"Experts - History"}></Help>
                </div>
            }

            {(checkWindowWidth() && isTabActive(menu.PACKAGES)) && 
                <div>
                    <ExpertsPackages />
                    <Help category={"MyAccount"} pageName={"Experts - Packages"}></Help> 
                </div>
            }

            {checkWindowWidth("gt") &&
            <Tabs className="profile-tabs menu-tabs submenu-tabs" activeKey={key} onSelect={(k) => { handleSetKey(k as menu); }}>
                <Tab eventKey={menu.INFO} title={t("Info")}>
                    <ExpertsInfo />
                    <Help category={"MyAccount"} pageName={"Experts - Info"}></Help>
                </Tab>
                <Tab eventKey={menu.HISTORY} title={t("History")}>
                    <ExpertsHistory />
                    <Help category={"MyAccount"} pageName={"Experts - History"}></Help>              
                </Tab>
                <Tab eventKey={menu.PACKAGES} title={t("Packages")}>
                    <ExpertsPackages />
                    <Help category={"MyAccount"} pageName={"Experts - Packages"}></Help>              
                </Tab>
            </Tabs>
            }
        </div>
    );
}

export default Experts;
